import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface WarPlanPanelState {
  isOpen: boolean;
  toggle: () => void;
  setOpen: (open: boolean) => void;
}

export const useWarPlanPanel = create<WarPlanPanelState>()(
  persist(
    (set) => ({
      isOpen: true,
      toggle: () => set((s) => ({ isOpen: !s.isOpen })),
      setOpen: (open) => set({ isOpen: open }),
    }),
    {
      name: 'warplan.war-plan-panel',
      partialize: (s) => ({ isOpen: s.isOpen }),
    },
  ),
);
